'use client';

import React from 'react';
import { generateSchemaMarkup } from '@/lib/utils/metadata';

interface SchemaMarkupProps {
  schema: object;
}

const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ schema }) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: generateSchemaMarkup(schema) }}
    />
  );
};

export default SchemaMarkup;
